import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { inject } from '@angular/core';

import {
    CanActivateFn,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import { AuthService } from './auth.service';
import { map, catchError } from 'rxjs/operators';

export const roleGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Observable<boolean> | boolean => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const myIdUrl = environment.apiSsoUrl;

    return authService.subscribeToLoginService().pipe(
        map((userInfo) => {
            if (userInfo != null && userInfo.userId != null) {
                let roles = route.data['roles'] as Array<string>;
                if (roles == null || (userInfo != null && roles.some(r => userInfo.role.indexOf(r) >= 0))) {
                    return true;
                }
                router.navigate(['/401']);
                return false;
            } else {
                if (!window.location.href.includes('token')) {
                    console.log(myIdUrl);

                    window.location.href = myIdUrl;
                    if (window.location.href.includes('/#/')) {
                        var url = window.location.href.slice(window.location.href.indexOf('#') + 1);
                        localStorage.setItem('redirectUrl', url);
                    }
                    return false;
                } else {
                    router.navigate(['/401']);
                    return false;
                }
            }
        }),
        catchError((err: any) => {
            console.log('error: ' + err);
            return of(false);
        })
    );
};

/**
 * @deprecated Use the functional `roleGuard` instead.
 * Kept for backward compatibility with any class-token references.
 */
export class RoleGuard {
    static ɵfac = () => roleGuard;
}
